var _defs, _path, _g, _path2, _path3, _path4, _path5, _rect, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgObjects02(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1500 1080",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#2ca0ff;}.cls-2{clip-path:url(#clip-path);}.cls-3{fill:#56c1fc;}.cls-4{fill:#f4e211;}.cls-5,.cls-7{stroke:#000;stroke-miterlimit:10;}.cls-5{stroke-width:2px;}.cls-6{fill:#9e3612;}.cls-7{fill:none;stroke-linecap:round;stroke-width:3px;}.cls-8{fill:#fff;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M439.92,379.18,499.3,157.5s172.2-73.23,502.74,0c0,0,55.42,9.9,55.42,203.87,0,0,29.69,314.71,55.42,475,0,0,18,128.43-74.15,128.43H428.05s-99-1.76-65.32-215.52L441.9,517.73Z"
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "objects") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M439.92,379.18,499.3,157.5s172.2-73.23,502.74,0c0,0,55.42,9.9,55.42,203.87,0,0,29.69,314.71,55.42,475,0,0,18,128.43-74.15,128.43H428.05s-99-1.76-65.32-215.52L441.9,517.73Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M910.77,208.68c-17.46,25.38-22.72,57.46-21.52,88.24s8.35,61,13.68,91.32a783.37,783.37,0,0,1,1.75,260.24c-7.19,44.39-18.24,88.48-18.55,133.44s11.7,92.32,43.94,123.66,87.87,40.62,122.61,12.08c19.15-15.72,29.5-40.16,33.09-64.67s1.1-49.47-1.39-74.12l-50.65-501.64c-3.14-31.12-7-75.05-32.76-97C972.42,155.9,929,182.19,910.77,208.68Z"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M450.7,389.08H800.18a34.61,34.61,0,0,0,34.62-34.82,728.76,728.76,0,0,1,3.1-74.94c6.55-66.08,57.3-119.67,123-129.19,1.16-.17,2.32-.33,3.5-.48,0,0-413.66-105-534.39,51.39,0,0-17.56,28.73-21.14,145A41.82,41.82,0,0,0,450.7,389.08Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M370.11,750.32l382.77,12.47a29.44,29.44,0,0,0,30.37-28.68c1.18-44.37,7-128.58,33-182.56,7.22-15-3.72-32.44-20.36-32.84l-371.76-8.9s-70.12,3.6-83.56,207.87A30.65,30.65,0,0,0,370.11,750.32Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M578.18,389.08h50.61a39.74,39.74,0,0,1,39.74,39.74v45.4a39.75,39.75,0,0,1-41.41,39.71l-50-2.1A39.75,39.75,0,0,1,539,472.66l-.58-43.31A39.74,39.74,0,0,1,578.18,389.08Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M584.83,405.49h37.31a29.29,29.29,0,0,1,29.29,29.3v33.46a29.3,29.3,0,0,1-30.52,29.28L584,496A29.3,29.3,0,0,1,556,467.1l-.43-31.92A29.3,29.3,0,0,1,584.83,405.49Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 591.67,
    y: 380.5,
    width: 17.81,
    height: 54.1,
    rx: 4.13
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M564.55,509.81s-12.16,31.7-44.23,63.77c0,0-2.22,34.87,28.46,65.55,0,0,38.25-34.13,69.94-46.19,0,0,23.41-44.55,8.4-79Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M906.22,216.27c-22.74,36.89-23.54,83.35-16.67,126.14S910.19,426.83,914.29,470c6.71,70.66-12.8,140.77-24.67,210.74s-15.13,146.16,20.49,207.55"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M880.07,159.4a162.87,162.87,0,0,0-79.55,179.84"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M655.76,377.4l118.38,3.29"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M659.9,537.46l141.72,5.1"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M772.75,599.64a261.27,261.27,0,0,0-35.68,130.71"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M362.51,695.52c-7.53,8.78-2.33,23.44,7.39,29.73s22,6.56,33.57,6.63l106.5.62"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M450.79,263.85c3.28,4.73,9.88,7.53,15,5,4.86-2.42,6.73-8.38,7.16-13.79s0-11.06,2.14-16,8.4-8.77,13.06-6c3.94,2.34,4.52,7.8,4.08,12.36s-1.38,9.54,1,13.48c3.69,6.23,13.86,5.51,18.62.06s5.2-13.48,4-20.62c-1.65-9.67-5.72-20.16-1-28.76C518.44,203,526,200,532.28,196c19.46-12.19,7.54-28.26-11.65-25-11.44,2-26.23,7.34-36.19,13.51C463.74,197.35,434.26,240,450.79,263.85Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgObjects02);
export default __webpack_public_path__ + "static/media/objects-02.cecad6587dfd7b2aa3ca457dc2350481.svg";
export { ForwardRef as ReactComponent };